// src/components/reports/SupervisorReport/ViewModeTabs.tsx
import React from 'react';
import { Box, Tab, Tabs } from '@mui/material';

type ViewMode = 'report' | 'chart' | 'table';

interface ViewModeTabsProps {
  viewMode: ViewMode;
  onViewModeChange: (event: React.SyntheticEvent, newValue: ViewMode) => void;
}

const ViewModeTabs: React.FC<ViewModeTabsProps> = ({ viewMode, onViewModeChange }) => {
  return (
    <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 2 }}>
      <Tabs value={viewMode} onChange={onViewModeChange} aria-label="表示モード">
        <Tab label="レポート" value="report" sx={{ fontWeight: 'bold' }} />
        <Tab label="グラフ表示" value="chart" />
        <Tab label="表形式" value="table" />
      </Tabs>
    </Box>
  );
};

export default ViewModeTabs;